import React from 'react'
import PropTypes from 'prop-types'

const PolygonIcon = ({ width = '8', height = '10', color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.96244e-08 5L7.5 0.669872L7.5 9.33013L5.96244e-08 5Z" fill={color} />
    </svg>
  )
}

export default React.memo(PolygonIcon)

PolygonIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}
